// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_117Js","list":"list_l6kio","btn":"btn_BkBlA","next-btn":"next-btn_3RdG2","un_active":"un_active_1fmq4","footer":"footer_1_GyQ","un_display":"un_display_261yE"};